var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"field"},[(_vm.pagerLoaded)?_c('p',[_vm._v("\n      "+_vm._s(this.$t("pager.show"))+" "+_vm._s(_vm.info.from)+" "+_vm._s(this.$t("pager.to"))+"\n      "+_vm._s(_vm.info.to)+" "+_vm._s(this.$t("pager.of"))+" "+_vm._s(_vm.info.total)+"\n      "+_vm._s(this.$t("pager.total"))+"\n    ")]):_vm._e()])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1661e29e","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./components/AdminTools/dataTable/paginationInfo.vue
// module id = null
// module chunks = 